import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';

HighchartsMore(Highcharts);

@Component({
  selector: 'cc-gaugechart',
  templateUrl: './gaugechart.component.html',
  styleUrls: ['./gaugechart.component.scss'],
})
export class GaugechartComponent implements OnInit, OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  gaugeChart: Highcharts.Options;
  gaugeValue: number;
  @Input() _sentimentValue: any;

  constructor() {}

  ngOnInit(): void {
   
  }

  createGauge(){
    this.gaugeChart = {
      chart: {
        type: 'gauge',
      },
      credits: {
        enabled: false
      },
      title: {
        text: '',
      },
      pane: {
        startAngle: -90,
        endAngle: 90,
        background: null,
      },
      yAxis: {
        min: 0,
        max: 2,
        tickPositions: [0, 1, 2],
        tickWidth: 0,
        tickLength: 10,
        tickColor: '#666',
        tickPosition: 'inside',
        labels: {
          distance: -30,
          formatter: function () {
            // Map numbers to text labels
            const labels = ['Bearish', 'Sideways', 'Bullish'];
            return labels[this.value as number] || '';
          },
          style: {
            fontSize: '80%',
            fontWeight: 'bold',
          },
        },
        plotBands: [
          {
            from: 0,
            to: 0.67,
            color: '#FF0000', // Bearish - Red
          },
          {
            from: 0.67,
            to: 1.33,
            color: '#FFCC00', // Sideways - Orangeish Yellow
          },
          {
            from: 1.33,
            to: 2,
            color: '#00FF00', // Bullish - Green
          },
        ],
      },
      series: [
        {
          name: 'Market Sentiment',
          type: 'gauge',
          data: [this.gaugeValue],
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            valueSuffix: '',
          },
        },
      ],
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    this.gaugeValue = changes._sentimentValue.currentValue;
    this.createGauge();
  }
}
